import TITLES from "constants/titles";
import { getFullName } from "utils/common";

import { APPOINTMENT_PROVIDER_OPTIONS } from "../merge-tags-options/appointment-provider.utils";
import { getPatientSignatureMergeTagOrPlaceholder } from "../merge-tags.utils";
import { MergeTagsReplaceHandler } from "./merge-tags-values";

// Resolves off the specific appointment the open document is bound to
// (data.boundAppointment), never the signed-in browser session — the fix
// for ENG-1644 (CurrentUser resolving to whoever's session touched the
// note, not the appointment's treating provider).
export const APPOINTMENT_PROVIDER_VALUES: MergeTagsReplaceHandler = {
  [APPOINTMENT_PROVIDER_OPTIONS.FULLNAME]: ({ data }) => {
    const staffMember = data.boundAppointment?.staffMember;
    return getFullName({
      firstName: staffMember?.first_name || "",
      lastName: staffMember?.last_name || "",
      title: staffMember?.title,
      suffix: staffMember?.suffix || ""
    });
  },
  [APPOINTMENT_PROVIDER_OPTIONS.FIRST_NAME]: ({ data }) => {
    return data.boundAppointment?.staffMember?.first_name;
  },
  [APPOINTMENT_PROVIDER_OPTIONS.LAST_NAME]: ({ data }) => {
    return data.boundAppointment?.staffMember?.last_name;
  },
  [APPOINTMENT_PROVIDER_OPTIONS.TITLE]: ({ data }) => {
    return TITLES.getFromCode(data.boundAppointment?.staffMember?.title);
  },
  [APPOINTMENT_PROVIDER_OPTIONS.SUFFIX]: ({ data }) => {
    return data.boundAppointment?.staffMember?.suffix;
  },
  [APPOINTMENT_PROVIDER_OPTIONS.SIGNATURE]: ({ data }) => {
    return getPatientSignatureMergeTagOrPlaceholder(
      data.boundAppointment?.staffMember?.signature
    );
  }
};
